import { Injectable } from '@angular/core';
import { Router } from '@angular/router'
import { AngularFireAuth } from '@angular/fire/auth'
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore'

// import { firebase } from '@firebase/app';
import { auth } from 'firebase/app';

import { switchMap, first } from 'rxjs/operators';
import { Observable } from 'rxjs/Rx';
import { of } from 'rxjs'

import { User } from 'shared-stuff'

@Injectable()
export class AuthService {


  uid: string; // userId of the person signed in (not necessarily an applicants uid)
  user: Observable<User>;
  userRef: AngularFirestoreDocument<User>

  constructor(
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private router: Router,
  ) {
    this.user = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          this.uid = user.uid;
          this.userRef = this.afs.doc<User>(`users/${user.uid}`)
          return this.afs.doc<User>(`users/${user.uid}`).valueChanges();
        } else {
          return of(null);
        }
      })
    );
  }

  // check if user is currently authenticated
  isLoggedIn() {
    return this.afAuth.authState.pipe(first()).toPromise();
  }

  // oAuth methods
  signOut() {
    // attempt to leave page to prompt user for unsaved any unsaved changes
    this.router.navigate(['pages', 'login']).then(allowedToLogout => {
      // allowedToLogout will be false if the user has unsaved changes and clicks cancel on the popup
      // it will be true in all other cases (no changes, changes but press okay)
      if (allowedToLogout) {
        this.afAuth.auth.signOut().then(() => {
          this.router.navigate(['pages', 'login']);
        });
      }
    })
  }
  googleLogin() {
    const provider = new auth.GoogleAuthProvider();
    return this.oAuthLogin(provider);
  }
  private oAuthLogin(provider: any) {
    return this.afAuth.auth.signInWithPopup(provider)
      .then(credential => {
        // console.log('successfully signed in', credential)
        return this.updateUserData(credential.user);
      })
      .catch(error => this.handleError(error));
  }

  // email auth methods
  emailSignUp(user: any) {
    return this.afAuth.auth
      .createUserWithEmailAndPassword(user.email, user.password)
      .then(credential => {
        user['uid'] = credential.user.uid
        
        // return this.updateUserData(credential.user);        
        return this.updateUserData(user);
      })
    // .catch(error => this.handleError(error));
  }

  emailLogin(email: string, password: string) {
    return this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
    // .then(credential => {
    //   return
    // })
    // .catch(error => this.handleError(error));
  }

  resetPassword(email: string) {
    const fbAuth = auth();

    return fbAuth.sendPasswordResetEmail(email).catch(error => console.error(error));

  }

  // strategy independent methods
  private handleError(error: Error) {
    console.error(error);
  }

  private updateUserData(user: User) {
    // creates user document if it doesn't exist, otherwise does a harmless merge
 
    let tempUser = Object.assign({},user);
    // @ts-ignore
    tempUser.password = null
    user.auditLog = [];
    let newAuditLog = { 
      actionTaken: "creation", 
      changeLocation: "register", 
      dateTimeOfChange: Date.now(),
      formChanges: tempUser
    }
    user.auditLog.push(newAuditLog);
    return this.afs.doc<User>(`users/${user.uid}`).set(user, { merge: true });
  }

}


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/core/auth.service.ts